<template lang="pug">
  .component-week-planner
    .days-selector
      p.mx-1 shifts number
      select(v-model="shiftCount")
        option(v-for="(value, key) in shiftCounts" :value="value") {{key}}

      p.mx-1 days to show
      input(type="number" v-model="daysToShow" max="21")

      p.mx-1 hour offset
      input(type="number" v-model="hourOffset" max="12")
    EasyWeeksWrapper(:daysToShow="Number(daysToShow)" :autoShift="shiftCount" :hourOffset="hourOffset")
</template>

<script type="text/babel">
  import EasyWeeksWrapper from "../../components/backoffice/EasyWeeksWrapper"

  export default {
    name: 'WeekPlanner',
    components: {
      EasyWeeksWrapper,
    },
    created() {
      let h = localStorage.getItem("hourOffset")
      this.hourOffset = h ? parseInt(h) : 0
      this.daysToShow = 14
      let x = localStorage.getItem("shiftCount")
      this.shiftCount = x ? parseInt(x) : 0
      this.shiftCounts = {
        'auto': 0,
        '2': 2,
        '4': 4,
        '6': 6,
        '12': 12,
        '24': 24,
      }
    },
    methods: {},
    data() {
      return {
        daysToShow: Number,
        shiftCount: Number,
        hourOffset: Number,
      }
    }
  }
</script>
<style lang="sass">
  .component-week-planner
    .days-selector
      display: flex
      justify-content: flex-end
      align-items: center

      select
        width: auto

      input
        width: 100%
        max-width: 4em

</style>



// WEBPACK FOOTER //
// WeekPlanner.vue?28099813